import { IDataTableColumn, useGridState, useSearchApi } from "nsitools-react";
import * as React from "react";

import { DysplasiaApi, UserDysplasiaResultSearch } from "../../../../api";
import { CustomDataTable } from "../../../../components";
import { useApiService, useTl } from "../../../../hooks";
import { ETLCodes } from "../../../../locales";

export interface IDysplasiaResultsRemarksListProps {
  dysplasiaRequestId: number;
  dysplasiaTypeId: number;
  characteristicId: number;
}

export const DysplasiaResultsRemarksList: React.FunctionComponent<IDysplasiaResultsRemarksListProps> = ({
  dysplasiaRequestId,
  dysplasiaTypeId,
  characteristicId,
}) => {
  const api = useApiService(DysplasiaApi);
  const { t } = useTl();

  const tableState = useGridState<any>({
    serverMode: true,
    enablePagination: false,
    enableFilter: false,
    availablePageSizes: [15, 25, 50],
    pageSize: 50,
    sortKeys: { veterinary: "DESC" },
  });

  const searchFunction = React.useCallback(
    (sObj?: UserDysplasiaResultSearch) => {
      return api.searchDysplasiaUserResult(
        UserDysplasiaResultSearch.fromJS({
          ...sObj,
          dysplasiaRequestId: dysplasiaRequestId,
          dysplasiaTypeId: dysplasiaTypeId,
          characteristicId: characteristicId,
        })
      );
    },
    [api, characteristicId, dysplasiaRequestId, dysplasiaTypeId]
  );

  const { loading } = useSearchApi<any, any>({
    searchFunction,
    tableState,
    initialSearch: true,
    trimSearchObjectStringValues: true,
  });

  const columns = React.useMemo<IDataTableColumn[]>(
    () => [
      {
        header: () => t(ETLCodes.Veterinary),
        fieldName: "veterinary",
      },
      {
        header: () => t(ETLCodes.OfficialRemark),
        fieldName: "officialRemark",
      },
      {
        header: () => t(ETLCodes.Remark),
        fieldName: "otherRemark",
      },
    ],
    [t]
  );

  return <CustomDataTable tableState={tableState} loading={loading} columns={columns} />;
};
